export default (number) => {
    if (!number) return number

    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}